import type { CityConfig } from "../city-template/types";

export const burlingtonIAConfig: CityConfig = {
  city: "Burlington",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "burlington-ia",
  route: "/burlington-ia",
  title: "Emergency Passport Burlington, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Burlington, IA — as fast as 24 hours. Serving Des Moines County and Southeast Iowa. A+ BBB rated registered State Dept. courier serving Snake Alley and the Mississippi River region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Burlington, IA",
  heroSubtitle: "Southeast Iowa business trip to London with two weeks notice? Mississippi River cruise and your passport expired? Snake Alley Art Fair weekend trip to Canada need fast documents? We help Burlington residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Burlington%20Iowa%20Mississippi%20River%20city%20Snake%20Alley%20winding%20brick%20street%20historic%20downtown%20buildings%20Riverside%20Park%20riverfront%20bluff%20overlooking%20the%20Mississippi%20river%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20soft%20natural%20tones%20Midwest%20charm&width=1800&height=700&seq=burlington-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Burlington Iowa Mississippi River city with Snake Alley historic downtown at golden hour",
  geoPosition: "40.8075;-91.1175",
  geoPlacename: "Burlington, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 275 miles east of Burlington via I-74/I-55",
  },
  nearbyCitiesZips: [
    { name: "Burlington", zips: "52601" },
    { name: "West Burlington", zips: "52655" },
    { name: "Fort Madison", zips: "52627" },
    { name: "Mount Pleasant", zips: "52641" },
    { name: "Keokuk", zips: "52632" },
    { name: "Muscatine", zips: "52761" },
    { name: "Mediapolis", zips: "52637" },
    { name: "Danville", zips: "52623" },
    { name: "Fairfield", zips: "52556, 52557" },
    { name: "Ottumwa", zips: "52501" },
    { name: "Washington", zips: "52353" },
    { name: "Monmouth", zips: "61462" },
    { name: "Galesburg", zips: "61401" },
    { name: "Macomb", zips: "61455" },
    { name: "Quincy", zips: "62301" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southeast Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Mississippi River Region", desc: "Serving Burlington, Fort Madison, Keokuk, and the Tri-State area" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Iowa City, IA", route: "/iowa-city" },
    { name: "Fast passport renewal in Davenport, IA", route: "/davenport" },
    { name: "Emergency passport help in Des Moines, IA", route: "/des-moines" },
    { name: "Urgent passport services in Cedar Rapids, IA", route: "/cedar-rapids" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in St. Louis, MO", route: "/st-louis" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Burlington remotely via secure courier. We do not have a walk-in office in Burlington — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Des Moines County and Southeast Iowa.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Des Moines County and the Mississippi River region including Lee, Henry, and Louisa counties",
  serviceAreaIntro: "From the historic brick streets of Snake Alley and the riverfront bluffs of Burlington to the Civil War landmarks of Keokuk, from the charming town squares of Mount Pleasant and Washington to the manufacturing community of Fort Madison, from the Danish heritage of Danville to the agricultural towns of Mediapolis and New London — Fast Passport Center serves the entire Southeast Iowa and Mississippi River region. We regularly help travelers from Des Moines County, Lee County, and surrounding areas get their passports fast without the 275-mile drive to Chicago.",
  nearbyCitiesIntro: "We serve all Burlington neighborhoods and the surrounding Southeast Iowa area including West Burlington, Fort Madison, Mount Pleasant, Keokuk, Muscatine, Mediapolis, Danville, Fairfield, Ottumwa, and Washington. If you are anywhere in Des Moines County, Lee County, or the Mississippi River Valley, we have you covered.",
  howItWorksIntro: "Most Burlington travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Burlington travelers often face a 4.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Burlington and Des Moines County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Burlington? Here are the most common ones we hear from Southeast Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa Vital Records (Birth, Death, Marriage)", href: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-user-line", label: "Des Moines County Recorder", href: "https://www.desmoinescounty.iowa.gov/160/Recorder" },
    { icon: "ri-map-pin-line", label: "Fort Madison Recorder", href: "https://www.fortmadisoniowa.gov/160/Recorder" },
    { icon: "ri-map-pin-line", label: "Keokuk Recorder", href: "https://www.keokukia.gov/160/Recorder" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Burlington travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Patricia V.",
      location: "Burlington, IA",
      rating: 5,
      text: "Our Italy vacation was in 5 days and I realized my passport had expired. Fast Passport Center had my renewal in 32 hours. I never left Burlington. Snake Alley to Rome in a week — insanity!",
      service: "Passport Renewal",
    },
    {
      name: "Ron C.",
      location: "Fort Madison, IA",
      rating: 5,
      text: "Medical emergency in Mexico City. Fast Passport Center got my passport in 26 hours. The dedicated agent handled everything. Best service I've ever used.",
      service: "Emergency Passport",
    },
    {
      name: "Kathy M.",
      location: "West Burlington, IA",
      rating: 5,
      text: "Both kids needed first passports for our Caribbean cruise. Fast Passport Center walked us through the child passport process. Got them in 4 days. Amazing for Southeast Iowa families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "burlington-ia-1",
      name: "Burlington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 N Main St",
      city: "Burlington",
      state: "IA",
      zip: "52601",
      phone: "(319) 753-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Burlington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Burlington facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "burlington-ia-2",
      name: "Des Moines County Recorder",
      type: "County Recorder Passport Acceptance",
      address: "513 N Main St",
      city: "Burlington",
      state: "IA",
      zip: "52601",
      phone: "(319) 753-8251",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Burlington Courthouse",
      website: "https://www.desmoinescounty.iowa.gov",
      websiteLabel: "Des Moines County Recorder",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "burlington-ia-3",
      name: "Fort Madison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1013 Avenue H",
      city: "Fort Madison",
      state: "IA",
      zip: "52627",
      phone: "(319) 372-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Burlington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lee County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "burlington-ia-4",
      name: "Keokuk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Blondeau St",
      city: "Keokuk",
      state: "IA",
      zip: "52632",
      phone: "(319) 524-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles south of Burlington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Keokuk and Tri-State area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "burlington-ia-5",
      name: "Mount Pleasant Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Jefferson St",
      city: "Mount Pleasant",
      state: "IA",
      zip: "52641",
      phone: "(319) 385-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles northwest of Burlington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Henry County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Burlington photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Des Moines County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Burlington applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Southeast Iowa families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Burlington travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Burlington." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Burlington address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Burlington before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Burlington for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Burlington?", a: "Fast Passport Center offers fast passport renewal in Burlington in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Burlington?", a: "The nearest regional passport agency to Burlington is the Chicago Passport Agency, approximately 275 miles east via I-74/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Burlington without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Burlington?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 4.5 hours from Burlington — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Des Moines County and Southeast Iowa residents." },
    { q: "Do you serve the entire Southeast Iowa region?", a: "Absolutely. Fast Passport Center serves the entire Southeast Iowa and Mississippi River region including Burlington, West Burlington, Fort Madison, Mount Pleasant, Keokuk, Muscatine, and surrounding areas. Our courier service works seamlessly from any address in Des Moines County, Lee County, or Henry County." },
    { q: "Can I expedite a child passport in Burlington?", a: "Yes. Fast Passport Center expedites child passports in Burlington for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Southeast Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Burlington with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Burlington", address: "324 W Agency Rd, West Burlington, IA 52655", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Burlington", address: "300 N Main St, Burlington, IA 52601", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Fort Madison", address: "1013 Avenue H, Fort Madison, IA 52627", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Mount Pleasant", address: "310 W Washington St, Mount Pleasant, IA 52641", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Burlington",
      address: "3131 Kirkwood St, Burlington, IA 52601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Mount Pleasant",
      address: "109 E Washington St, Mount Pleasant, IA 52641",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Henry County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Fort Madison",
      address: "2683 340th St, Fort Madison, IA 52627",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lee County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BRL",
      name: "Southeast Iowa Regional Airport",
      distance: "5 miles southeast of Burlington",
      address: "2515 Summer St, Burlington, IA 52601",
      note: "Regional airport with direct flights to St. Louis via Air Choice One. About 10 minutes from downtown Burlington.",
      flightUrl: "https://www.burlingtoniowa.org/airport",
      flightLabel: "BRL Airport",
      featured: true,
    },
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "75 miles northeast of Burlington",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport with direct flights to major hubs. About 1 hour 25 minutes from Burlington.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: false,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "165 miles west of Burlington",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Major Iowa airport with direct flights nationwide. About 2 hours 45 minutes from Burlington.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
  ],
};